import React from 'react';
import AssetTable from '../components/AssetTable';

export default function CryptoPage() {
  return <AssetTable type="crypto" title="Kryptowährungen" icon="fa-solid fa-coins" chartType="stock" />;
}
